export default __webpack_public_path__ + "488783a49348f906ad855ccefa0c7fec.svg";